module.exports = __webpack_public_path__ + "img/faq3.f7d4ef19.png";